export default function () {
  const messageEl = document.getElementById("js-affirm-payment-message")

  if (messageEl) {
    const stripe = Stripe(messageEl.dataset.stripePublicKey)
    let elements

    const appearance = {
      theme: "stripe",
      variables: {
        colorPrimary: messageEl.dataset.colorPrimary,
        colorBackground: "#ffffff",
        colorText: "#1c1c1c",
        fontFamily: "Graphik Web, Helvetica Neue, Helvetica, Arial, sans-serif",
        spacingUnit: "6px",
        fontSizeBase: "18px",
        fontSizeSm: "18px",
        fontSize3Xs: "16px",
      },
    }

    elements = stripe.elements({ appearance })

    const options = {
      amount: parseInt(messageEl.dataset.amount, 10),
      currency: "USD",
      countryCode: "US",
      paymentMethodTypes: ["affirm"],
    }

    const paymentMessageElement = elements.create("paymentMethodMessaging", options)
    paymentMessageElement.mount("#js-affirm-payment-message")
  }
}
